import React from "react";
import SliderContent from "./SliderContent";
import { Slider } from "../../../../components";

const OurFleet = () => {
  return (
    <div className="bg-dark">
      <div className="md:grid grid-cols-1 py-1 place-items-center gap-3 ">
      <div className="space-y-4">
          <div className="text-center">
            <div>
                <h1 className="text-yellow font-bold">Our Fleets</h1>
            </div>
          </div>
        </div>
        </div>
      <div className="md:grid grid-cols-4 py-1 place-items-center gap-3 px-10">
        
        
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/Group 22.png" width="200px" />
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/Group 23.png" width="200px" />
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/Group 24.png" width="200px" />
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div className="text-center">
            <div>
                <img src="/static/images/Group 25.png" width="200px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurFleet;
